import React from 'react';
import {useIntl} from 'gatsby-plugin-intl';
import PublishedDate from './published-date/PublishedDate.component';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {Link} from 'gatsby'
import multilingualSlugs from '../../../intl/slugs.json';
import {PageType} from '@constants/pageType.constants';
import {ContentType} from '../../../types/wordpress.types';
import {Play} from '@components/play/Play.component';
import {i18nPrefixCode} from '@helpers/linking.helper';
import s from './Card.module.scss';

interface ICard {
  title: string,
  categories: string[],
  featuredImage: any,
  date: any,
  contentType: any,
  slug: any,
}

export const Card = ({
                       title,
                       categories,
                       featuredImage,
                       date,
                       slug,
                       contentType,
                     }: ICard) => {

  const intl = useIntl();

  if (!title || !categories || !featuredImage) return null

  const image = getImage(featuredImage.node.localFile.childImageSharp)


  const routeArticle =
    i18nPrefixCode(intl.locale) +
    multilingualSlugs[intl.locale][PageType.KNOWLEDGE_BASE] +
    multilingualSlugs[intl.locale][PageType.ARTICLE]

  const routeCategory =
    i18nPrefixCode(intl.locale) +
    multilingualSlugs[intl.locale][PageType.KNOWLEDGE_BASE] +
    multilingualSlugs[intl.locale][PageType.CATEGORY]

  return (
    <div className={s.card}>
      <Link className={s.card__image}
            rel={'nofollow'}
            to={routeArticle + '/' + slug}
      >
        {
          contentType === ContentType.video &&
          <>
            <div className={s.card__play}>
              <Play watchVideoText={intl.formatMessage({id: 'common__watchTheVideo'})}/>
            </div>
            <div className={s.card__bg}/>
          </>
        }
        <GatsbyImage alt={featuredImage.node.altText} image={image} className={s.card__imageImg}/>
      </Link>
      <div className={s.card__info}>
        <div className={s.card__categories}>
          {
            categories.nodes.map(category => {
                return (
                  <Link to={routeCategory + `/${category.slug}`}>
                  <span className={s.card__category} id={category.id} key={category.name}>
                    {category.name}
                  </span>
                  </Link>
                );
              },
            )
          }
        </div>
        <div className={s.card__wrapper}>
          <Link className={s.card__readMore}
                rel={'nofollow'}
                to={routeArticle + '/' + slug}
          >
            <h3 className={s.card__title}>{title ? title : 'Post title'}</h3>
          </Link>
        </div>
        <div className={s.card__lastLine}>
          {date &&
            <div className={s.card__publish}>
              <PublishedDate publishedDate={date} isAuthorAvailable={false}/>
            </div>
          }
          <Link className={s.card__readMore}
                rel={'nofollow'}
                to={routeArticle + '/' + slug}
          >
            Read more
          </Link>
        </div>
      </div>
    </div>
  );
};
